export default "__VITE_PUBLIC_ASSET__2ee22695__"